import { useState } from "react";
import { ClipLoader } from "react-spinners";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

function Loader() {
  let [loading, setLoading] = useState(true);
  let [color, setColor] = useState("#ffffff");

  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      <ClipLoader
        color={color}
        loading={loading}
        size={20}
        aria-label="Loading Spinner"
        data-testid="loader"
        className="me-4"
      />
      Loading ...
    </div>
  );
}

export default Loader;